import { ColorPicker } from './ColorPicker';

interface Props {
  label: string;
  value: string | null;
  /** The colors on offer, each with its accessible name. */
  options: readonly { value: string; label: string }[];
  /** The accessible name of the "no color" choice (always offered). */
  noneLabel: string;
  onPick: (color: string | null) => void;
  disabled?: boolean;
  /** Also any `#rrggbb` (the server takes it). */
  custom?: boolean;
  workspaceId?: string;
}

/**
 * A palette plus "no color" - for colors that identify an object (a workspace, a database, a
 * table). The shared `ColorPicker`: the choice is announced by name, never by color alone.
 */
export function PalettePicker({
  label,
  value,
  options,
  noneLabel,
  onPick,
  disabled = false,
  custom = false,
  workspaceId,
}: Props) {
  return (
    <ColorPicker
      label={label}
      value={value}
      options={options}
      noneLabel={noneLabel}
      onPick={onPick}
      disabled={disabled}
      custom={custom}
      {...(workspaceId && { workspaceId })}
    />
  );
}
